
import CrossCommSession from "../CrossCommSession";
import EventMessage from "../EventMesssage";
import {RequestActionsConstant} from "./RequestActionsConstant";
import RequestBase from "./RequestBase";

export default class EventRequest extends RequestBase {
    public constructor(
        public readonly crossCommSession: CrossCommSession,
        public readonly teamsToken: string,
        public readonly eventMessages: EventMessage[]
    ) {
        super();
        this.action = RequestActionsConstant.EVENT_LOG;
    }
}
